exports.components = {
  "component---src-components-templates-product-internal-template-jsx": () => import("./../../../src/components/templates/product-internal-template.jsx" /* webpackChunkName: "component---src-components-templates-product-internal-template-jsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

